import React, {Component} from 'react';
import './index.scss';
import DefaultLayout from 'layouts/Default';

export default class PrivacyPolicyPage extends Component {

  render() {
    return <DefaultLayout id="privacy-policy-page">
      <h1>Privacy Policy</h1>
      <p>Sook Retail Ltd understands that your privacy is important to you and that you care about how your personal
        data is used. We respect and value the privacy of everyone who visits this website [<a
          href="https://www.google.com/url?q=https://www.sook.space/&amp;sa=D&amp;source=editors&amp;ust=1636671774909000&amp;usg=AOvVaw3AjavdgoOXFc5lhQCTtnIN">https://www.sook.space/</a>],
        and will only collect and use personal data in ways that are described here, and in a way that is consistent
        with our obligations and your rights under the law.
      </p>
      <p>Please read this Privacy Policy carefully and ensure that you understand it. Your acceptance of this Privacy
        Policy is subject to your acceptance of our website&rsquo;s Terms and Conditions of Use which can be found <a
          href="https://www.google.com/url?q=https://www.sook.space/legal/terms-and-conditions&amp;sa=D&amp;source=editors&amp;ust=1636671774910000&amp;usg=AOvVaw2hTy8-DXmDIgtjGiFTDM5V">https://www.sook.space/legal/terms-and-conditions</a> .
        Your agreement to be bound by both this Privacy Policy and the linked Terms and Conditions of Use is deemed to
        occur upon your first use of the Website. If you do not wish to be bound by either document you should stop
        using the website immediately.
      </p>
      <ol>
        <li>
          <h3>Definitions and Interpretations</h3>
          <p>In this Policy the following terms shall be construed as having the following meanings:</p>
          <p>
            &ldquo;Account&rdquo;  means an account required to access and or use certain
          </p>
          <p>areas and features of our site. </p>
          <p>
            &ldquo;Cookie&rdquo; means a small text file placed on your computer or device by
          </p>
          <p>Our Site when you visit certain parts of Our Site and / or when you use certain features of Our Site.
            Details of the Cookies used are set out in our Cookie Policy (insert link). </p>
          <p>
            &ldquo;Cookie Law&rdquo; means the relevant parts of the Privacy and Electronic</p>
          <p>Communications (EC Directive) Regulations 2003. </p>
          <p> &ldquo;Data&rdquo; collectively all information that you submit to Sook Retail
          </p>
          <p>Ltd via the Website. This definition includes, where applicable, the definitions provided in the Data
            Protection Laws.
          </p>
          <p>
            &ldquo;Website&rdquo; The website that you are currently using, <a
            href="https://www.google.com/url?q=http://www.sook.space&amp;sa=D&amp;source=editors&amp;ust=1636671774912000&amp;usg=AOvVaw0GvXeJ5PKnny00SbfudGF1">www.sook.space</a>,
          </p>
          <p>and any sub domains of this site, unless expressly excluded by their own terms and conditions.
          </p>
        </li>
        <li>
          <h3>Information About Us</h3>
          <p>Our Site is owned and operated by Sook Retail Ltd, and Limited Company, Registered in England under the
            company number 11912445. </p>
          <p>Registered address: 61-65 Church Street, Harston, Cambridge CB22 7NP</p>
        </li>
        <li>
          <h3>Policy Scope</h3>
          <p>This Privacy Policy applies only to your use of Our Site. Our Site may contain links to other websites.
            Please note that we have no control over how your data is collected, stored or used by other websites and we
            advise that you check the privacy policies of any such websites before providing any data to them.</p>
        </li>
        <li>
          <h3>What Is Personal Data</h3>
          <p>Personal data is defined by the UK GDPR and the Data Protection Act 2018 (Collectively the &ldquo;Data
            Protection Legislation&rdquo;) as &lsquo;any information relating to an identifiable person who can be
            directly or indirectly identified in particular by reference to an identifier&rsquo;.
          </p>
          <p>Personal data is, in simpler terms, any information about you that enables you to be identified. Personal
            data covers obvious information such as your name and contact details, but it also covers less obvious
            information such as identification numbers, electronic location data and other online identifiers.
          </p>
        </li>
        <li>
          <h3>What Are My Rights</h3>
          <p>Under the Data Protection Legislation, you have the following rights, which we will always work to uphold:
          </p>
          <ol start={1}>
            <li>The right to be informed about our collection and use of your personal data. This Privacy Policy should
              tell you everything you need to know, but you can contact us using the details in Part 15.
            </li>
            <li>The right to access the personal data we hold about you. For more information see Part 13.
            </li>
            <li>The right to have your personal data rectified if any of your personal data held by us is inaccurate or
              incomplete.
            </li>
            <li>The right to be forgotten, i.e.the right to ask us to delete or otherwise dispose of any of your
              personal data that we hold.
            </li>
            <li>The right to restrict or prevent the processing of your personal data.</li>
            <li>The right to object to us using your personal data for a particular purpose or purposes.</li>
            <li>The right to withdraw consent as the legal basis for us using your personal data, you are free to
              withdraw that consent at any time.</li>
            <li>The right to use data portability. This means that if you have provided personal data to us directly, we
              are using it with your consent or for the performance of a contract, and that data is processed using
              automated means, you can ask us for a copy of that personal data to re-use with another service or
              business in many cases.
            </li>
            <li>Rights referring to automated decision-making and profiting.</li>
          </ol>
          <p>It is important that your personal data is kept accurate and up-to-date. If any of the personal data we
            hold about you changes, please keep us informed as long as we hold that data.
          </p>
          <p>Further information about your rights can also be obtained from the Information Commissioner&rsquo;s Office
            or your local Citizen&rsquo;s Advice Bureau.
          </p>
          <p>If you have any cause for complaint about our use of your personal data, you have the right to lodge a
            complaint with the Information Commissioner&rsquo;s Bureau.
          </p>
        </li>
        <li>
          <h3>What Data Do We Collect, and How?</h3>
          <p>Depending on your use of our site, we may collect and hold some or all of the personal and non-personal
            data set out below, using the methods also detailed below. Please refer to our Cookies Policy for more
            information regarding our use of Cookies and similar technologies. We do not collect any &lsquo;special
            category&rsquo; or &lsquo;sensitive&rsquo; personal data, data relating to children, or data relating to
            criminal convictions and/or offences.
          </p>
          <p>Information that you provide to us</p>
          <ul>
            <li>Identity information, such as your name, title, date of birth, gender;
            </li>
            <li>Contact information, such as email address, address, telephone number;
            </li>
            <li>Business information including business name, profession;
            </li>
            <li>Payment information card details, bank account numbers;</li>
            <li>Profile information such as preferences, interest, login details, purchase history.
            </li>
          </ul>
          <p>Information we collect about you</p>
          <ul>
            <li>Technical information such as IP address, browser type and version, operating system, times dates,
              frequency with which you access the website and the way you use the content.
            </li>
          </ul>
          <p>Information we receive from other sources </p>
          <ul>
            <li>Data we receive from third parties, primarily Google Analytics and Hubspot containing technical
              information, profile information, contact information.
            </li>
          </ul>
        </li>
        <li>
          <h3>How Do We Use Your Personal Data?</h3>
          <p>Under the Data Protection Legislation we must always have a lawful basis for using personal data.</p>
          <p>These are the principal grounds that justify our use of your information:</p>
          <table>
            <colgroup>
              <col width="250" />
              <col />
            </colgroup>
            <tbody>
            <tr>
              <th>Consent</th>
              <td>where you have consented to our use of your information
                (you are providing explicit, informed, freely given consent, in relation to any such use and may
                withdraw your consent in the circumstance detailed below)
              </td>
            </tr>
            <tr>
              <th>Contract performance</th>
              <td>where your information is necessary to enter into to perform our contract with you</td>
            </tr>
            <tr>
              <th>Legal obligation</th>
              <td>where we need to use your information to comply with our legal obligations</td>
            </tr>
            <tr>
              <th>Legitimate interest</th>
              <td>where we use your information to achieve a legitimate interest and our reasons for using it outweigh
                any prejudice to your data protections rights
              </td>
            </tr>
            <tr>
              <th>Legal claims</th>
              <td>where your information is necessary for us to defend, prosecute or make claim against you or a third
                party
              </td>
            </tr>
            </tbody>
          </table>
          <p>
            The following table describes how we will use your personal data, and our lawful basis for doing so.
          </p>
          <table>
            <colgroup>
              <col width="33%" />
              <col width="33%" />
              <col width="33%" />
            </colgroup>
            <thead>
            <tr>
              <th colSpan={1} rowSpan={1}>What We Do</th>
              <th colSpan={1} rowSpan={1}>What Data We Use</th>
              <th colSpan={1} rowSpan={1}>Our Lawful Basis</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td colSpan={1} rowSpan={1}>Registering you on our site</td>
              <td colSpan={1} rowSpan={1}>First name, surname, email address
              </td>
              <td colSpan={1} rowSpan={1}>Legitimate interest (to administer users)</td>
            </tr>
            <tr>
              <td colSpan={1} rowSpan={1}>Providing and managing your account
              </td>
              <td colSpan={1} rowSpan={1}>First name, surname, email address, phone number, feedback survey
                information
              </td>
              <td colSpan={1} rowSpan={1}>Contract performance</td>
            </tr>
            <tr>
              <td colSpan={1} rowSpan={1}>Providing and managing your access to our site
              </td>
              <td colSpan={1} rowSpan={1}>First name, surname, email address, phone number, feedback survey
                information
              </td>
              <td colSpan={1} rowSpan={1}>Contract performance</td>
            </tr>
            <tr>
              <td colSpan={1} rowSpan={1}>Personalising and tailoring your experience on our site
              </td>
              <td colSpan={1} rowSpan={1}>First name, surname, email address, phone number, feedback survey
                information
              </td>
              <td colSpan={1} rowSpan={1}>Legitimate interest (to administer users)</td>
            </tr>
            <tr>
              <td colSpan={1} rowSpan={1}>Administering our site</td>
              <td colSpan={1} rowSpan={1}>Individual and/or company name, individual and/or company address
              </td>
              <td colSpan={1} rowSpan={1}>Contract performance </td>
            </tr>
            <tr>
              <td colSpan={1} rowSpan={1}>Administering our business</td>
              <td colSpan={1} rowSpan={1}>Individual and/or company name, individual and/or company address
              </td>
              <td colSpan={1} rowSpan={1}>Contract performance </td>
            </tr>
            <tr>
              <td colSpan={1} rowSpan={1}>Supplying our services to you, ensuring the content provided is presented
                in the most effective manner for you and your device.
              </td>
              <td colSpan={1} rowSpan={1}>First name, surname, email address
              </td>
              <td colSpan={1} rowSpan={1}>Legitimate interest (to administer and improve our Website)
              </td>
            </tr>
            <tr>
              <td colSpan={1} rowSpan={1}>Managing payments for our services
              </td>
              <td colSpan={1} rowSpan={1}>Billing name, billing address, partial bank account number, partial bank
                sort code, partial payment information
              </td>
              <td colSpan={1} rowSpan={1}>Contract performance</td>
            </tr>
            <tr>
              <td colSpan={1} rowSpan={1}>Personalising and tailoring our services for you
              </td>
              <td colSpan={1} rowSpan={1}>First name, surname, email address, phone number, feedback survey
                information
              </td>
              <td colSpan={1} rowSpan={1}>Legitimate interest (to administer users)</td>
            </tr>
            <tr>
              <td colSpan={1} rowSpan={1}>Communicating with you</td>
              <td colSpan={1} rowSpan={1}>First name, surname, email address, phone number, feedback survey
                information
              </td>
              <td colSpan={1} rowSpan={1}>Consent</td>
            </tr>
            <tr>
              <td colSpan={1} rowSpan={1}>Supplying you with information by email that you have opted in to (you may
                opt out at any time)
              </td>
              <td colSpan={1} rowSpan={1}>First name, surname, email address, phone number, feedback survey
                information
              </td>
              <td colSpan={1} rowSpan={1}>Consent</td>
            </tr>
            <tr>
              <td colSpan={1} rowSpan={1}>
                <p>For marketing, provided always that we</p>
                <p>i) only use aggregated and anonymised data or</p>
                <p>ii) only engage in direct marketing for products and/or services provided by Sook Retail Ltd
                  (including marketing spaces and our analytics services) that we believe will be of interest to you or
                  only where you have explicitly consented to this
                </p>
              </td>
              <td colSpan={1} rowSpan={1}><p>First name, surname, email address, address, phone number, business
                address, Hubspot information, Facebook lead generation form information
              </p></td>
              <td colSpan={1} rowSpan={1}><p>Legitimate interest (for marketing our own similar products and services
                and any re-engagement campaigns)
              </p>
              <p>Consent (for marketing unrelated products or services of third parties)</p>
              </td>
            </tr>
            </tbody>
          </table>
          <p>With your permission and/or where permitted by law, we may also use your personal data for marketing
            purposes, which may include contacting you by email and/or telephone, and/or text message, and/or post with
            information, news, and offers on our services. You will not be sent any unlawful marketing or spam. We will
            always work to fully protect your rights and comply with our obligations under the Data Protection
            Legislation and the Privacy and Electronic Communications (EC Directive) Regulations 2003, and your express
            opt-in consent before sharing your personal data with third parties for marketing purposes and you will be
            able to opt-out at any time.
          </p>
          <p>We will only use your personal data for the purpose(s) for which it was originally collected unless we
            reasonably believe that another purpose is compatible with that or those original purposes(s) and need to
            use your personal data for that purpose. If we do use your personal data in this way and you wish us to
            explain how the new purpose is compatible with the original please contact us using the details in Part
            7.</p>
          <p>IF we need to use your personal data for a purpose that is unrelated to, or incompatible with, the
            purpose(s) for which it was originally collected, we will inform you to explain the legal basis which allows
            us to do so.
          </p>
          <p>In some circumstances, where permitted or required by law, we may process your personal data without your
            knowledge or consent. This will only be done within the bounds of Data Protection Legislation and your legal
            rights.
          </p>
        </li>
        <li>
          <h3>How Long Will You Keep My Personal Data?</h3>
          <p>We will only retain your Personal Data for as long as reasonably necessary to fulfil the purposes we
            collected it for. We need to retain identity, contact, business and profile information so as to keep a
            record of which profiles are linked to which user and the spaces they have previously occupied.
          </p>
          <p>Unless a longer retention period is required, or permitted by law, we will only hold your data on our
            systems for the period of time necessary to fulfil the purposes outlined in this privacy policy, or until
            you request that the data be deleted.
          </p>
          <p>Even if we delete your data, it may persist on backup or archival media for legal, tax or regulatory
            purposes.
          </p>
        </li>
        <li>
          <h3>How Do We Store or Transfer Your Personal Data? </h3>
          <p>We will store some of your personal data in the UK. This means that it will be fully protected under the
            Data Protection Legislation.
          </p>
          <p>We will store some of your data within the European Economic Area (the EEA). The EEA consists of all EU
            member states, plus Norway, Iceland, and Liechtenstein. This means that your personal data will be fully
            protected under the EU GDPR and/or equivalent standards by law. Transfers of personal data to the EEA from
            the UK are permitted without additional safeguards.
          </p>
          <p>
            We may store some or all of your personal data in countries outside of the UK. These are known
            as &lsquo;third countries&rsquo;. We will take additional steps in order to ensure that your personal data
            is treated just as safely and securely as it would be within the UK and under the Data Protection
            Legislation as follows:
          </p>
          <p>We will only store or transfer personal data in or to countries that are deemed to provide an adequate
            level of protection for personal data. For further information about adequacy decision and adequacy
            regulation, please refer to the Information Commissioner&rsquo;s Office.
          </p>
        </li>
        <li>
          <h3>Do We Share Your Personal Data?</h3>
          <p>We will not share any of your personal data with any third parties for any purposes, subject to the
            following exceptions.
          </p>
          <p>If we sell, transfer, or merge parts of our business or assets, your personal data may be transferred to a
            third party. Any new owner of our business may continue to use your personal data in the same way(s) that we
            have used it, as is specified in this Privacy Policy.
          </p>
          <p>In some limited circumstances, we may be legally required to share certain personal data, which may include
            yours, if we are involved in legal proceedings or complying with legal obligations, a court order, or the
            instructions of a government authority.
          </p>
          <p>If any of your personal data is shared with a third party, we will take steps to ensure that your personal
            data is handled safely, securely, and in accordance with your rights, our obligations and the third
            party&rsquo;s obligations, as described above in Part 9.
          </p>
        </li>
        <li>
          <h3>How Can You Control Your Personal Data?</h3>
          <p>In addition to your rights under the Data Protection Legislation, set out in Part 12, when you submit
            personal data via our website, you may be given options to restrict our use of personal data. In particular,
            we aim to give you strong controls on out use of your data for direct marketing purposes (including the
            ability to opt-out of receiving emails from us which you may do by unsubscribing using the links provided in
            out emails and, at the point of providing you details, and by managing your account.
          </p>
          <p>You may also wish to sign up to one or more of the preference services operating in the UK: The Telephone
            Preference Service (the TPS), the Corporate Telephone Preference Service (the CTPS), and the Mailing
            Preference Service (the MPS). These may prevent you from receiving unsolicited marketing. Please note,
            however, that these services will not prevent you from receiving marketing communications that you have
            consented to receiving.
          </p>
        </li>
        <li>
          <h3>Can You Withhold Information?</h3>
          <p>You may access certain areas of our site without providing any personal data at all. However, to use all
            features and functions available on our site, you may be required to submit or allow for the collection of
            certain data.
          </p>
          <p>You may restrict our use of Cookies. For more information, see our Cookie Policy below. </p>
        </li>
        <li>
          <h3>How Can You Access Your Personal Data?</h3>
          <p>If you want to know what personal data we have about you, you can ask us for details of that personal data
            and for a copy of it (where any such personal data is held). This is known as a &ldquo;subject access
            request&rdquo;.
          </p>
          <p>All subject access requests should be made in writing and sent to the email or postal addresses shown in
            Part 14. There is not normally a charge for a subject access request, however, if your request
            is &lsquo;manifestly unfounded or excessive&rsquo; (for example, if you make repetitive requests) a fee may
            be charged to cover our administrative costs in responding.
          </p>
          <p>We will respond to your access request within one month of receiving it. Normally we aim to provide a
            complete response, including a copy of your personal data within that time. In some cases, however,
            particularly if your request is more complex, more time may be required up to a maximum of three months from
            the date we receive our request. You will be kept fully informed of our progress.
          </p>
        </li>
        <li>
          <h3>How Can You Contact Us?</h3>
          <p>To contact us about anything to do with your personal data and data protection, including to make a subject
            access request, please use the following details:
          </p>
          <p> Email address: enquiries@sook.space</p>
          <p> Postal address: 81 Burton Street, Derby, Derbyshire DE1 1TJ
          </p>
        </li>
        <li>
          <h3>Changes to this Privacy Policy</h3>
          <p>We may change this Privacy Policy from time to time. This may be necessary, for example if the law changes,
            or if we change our business in a way that affects personal data protection.
          </p>
          <p>Any changes will be posted on our website and you will be deemed to have accepted the terms of the Privacy
            Policy on your first use of our site following the alteration. We recommend that you check this page
            regularly to keep up-to-date.
          </p>
          <p>This Privacy Policy was last updated on 15th October 2021. </p>
        </li>
      </ol>
      <h2>WEBSITE COOKIES POLICY</h2>
      <h3>How Do We Use Cookies?</h3>
      <p>Our site may place and access certain first-party Cookies on your computer or device. First-party Cookies are
        those placed directly by use and are used only by us. We use Cookies to facilitate and improve your experience
        of our Site and to provide and improve our products and services. We have carefully chosen these Cookies and
        have taken steps to ensure that your privacy and personal data is protected and respected at all times.
      </p>
      <p>All Cookies used by and on our site are used in accordance with current Cookie law. </p>
      <p>Before Cookies are placed on your computer or device, you will be shown a pop-up requesting your consent to set
        those Cookies. By giving your consent to the placing of Cookies you are enabling us to provide the best possible
        experience and service to you. You may, if you wish, deny consent to the placing of Cookies; however, certain
        features of our site may not function fully or as intended.
      </p>
      <h4>First Party Providers</h4>
      <p>
        Certain features of our site depend on Cookies to function. Cookie Law deems these Cookies to be &ldquo;strictly
        necessary&rdquo;. These Cookies are shown in the table below. Your consent will not be sought to place these
        Cookies, but it is still important that you are aware of them. You may still block these Cookies by changing
        your internet browser&rsquo;s settings as detailed below, but please be aware that our site may not work
        properly if you do so. We have taken great care to ensure that your privacy is not at risk by allowing them.
      </p>
      <p>The following first-party Cookies may be placed on your computer or device:</p>
      <table>
        <thead>
          <tr>
            <th colSpan={1} rowSpan={1}>Name of Cookie</th>
            <th colSpan={1} rowSpan={1}>Purpose</th>
            <th colSpan={1} rowSpan={1}>Strictly Necessary</th>
            <th colSpan={1} rowSpan={1}>Expires</th>
          </tr>
        </thead>
        <tbody>
        <tr>
          <td colSpan={1} rowSpan={1}>sook.session</td>
          <td colSpan={1} rowSpan={1}>Used to keep you signed in</td>
          <td colSpan={1} rowSpan={1}>Yes</td>
          <td colSpan={1} rowSpan={1}>7 days</td>
        </tr>
        <tr>
          <td colSpan={1} rowSpan={1}>cookiesAccepted</td>
          <td colSpan={1} rowSpan={1}>Saves your cookie consent settings</td>
          <td colSpan={1} rowSpan={1}>Yes</td>
          <td colSpan={1} rowSpan={1}>Never</td>
        </tr>
        </tbody>
      </table>
      <h4>Third Party Providers</h4>
      <p>Our site uses analytics services provided by multiple analytics programs. Website analytics refers to a set of
        tools used to collect and analyse anonymous usage information, enabling us to better understand how our site is
        used. This, in turn, enables us to improve our site and the products and services offered through it.
      </p>
      <p>Google Analytics is not allowed to use or share our analytics data with anyone else. The program stores
        information about
      </p>
      <p>The analytics services used by our site uses Cookies to gather the required information. You do not have to
        allow us to use these Cookies, however, whilst our use of them does not pose any risk to your privacy or your
        safe use of our site, it does enable us to continually improve our Site, making it a better and more useful
        experience for you.
      </p>
      <p>The analytics services used by our site may use, but is not limited to, the following Cookies:
      </p>
      <table>
        <colgroup>
          <col width="20%" />
          <col width="15%" />
          <col width="50%" />
          <col width="15%" />
        </colgroup>
        <thead>
          <tr>
            <th colSpan={1} rowSpan={1}>Name</th>
            <th colSpan={1} rowSpan={1}>Provider</th>
            <th colSpan={1} rowSpan={1}>Purpose</th>
            <th colSpan={1} rowSpan={1}>Expires</th>
          </tr>
        </thead>
        <tbody>
        <tr>
          <td colSpan={1} rowSpan={1}>
            _ga<br />
            _gid</td>
          <td colSpan={1} rowSpan={1}>Google Analytics</td>
          <td colSpan={1} rowSpan={1}>Checks if you&rsquo;ve visited sook.space before. This helps us to count how
            many people visit our site.
          </td>
          <td colSpan={1} rowSpan={1}>2 years<br />
            24 hours</td>
        </tr>
        <tr>
          <td colSpan={1} rowSpan={1}>DSID<br />
            IDE<br />
            RUL</td>
          <td colSpan={1} rowSpan={1}>Google DoubleClick</td>
          <td colSpan={1} rowSpan={1}>These cookies enable us to track and analyse the performance of advertising
            campaigns we run on the website. They also help us to identify how long and the bounce rate of users of the
            website.
          </td>
          <td colSpan={1} rowSpan={1}>2 weeks<br />
            13 months<br />
            13 months</td>
        </tr>
        <tr>
          <td colSpan={1} rowSpan={1}>CONSENT<br />
            NID<br />
            _Secure-3PAPISID<br />
            _Secure-3PSID<br />
            _Secure-3PSIDCC<br />
            1P_JAR<br />
            AID</td>
          <td colSpan={1} rowSpan={1}>Google</td>
          <td colSpan={1} rowSpan={1}>The cookies we use from Google enable us to understand the demographic of
            people reaching our site through advertisement. This enables us to use our advertising in a more targeted
            and therefore more effective manner.
          
            Also allows the user to log into the site using their Google credentials. </td>
          <td colSpan={1} rowSpan={1}>Session<br />
            6 months<br />
            30 days<br />
            30 days<br />
            30 days<br />
            30 days<br />
            30 days</td>
        </tr>
        <tr>
          <td colSpan={1} rowSpan={1}>c_user<br />
            datr<br />
            fr<br />
            sb<br />
            spin <br />
            xs </td>
          <td colSpan={1} rowSpan={1}>Facebook</td>
          <td colSpan={1} rowSpan={1}>The cookies we use from Facebook enable us to better understand the demographic
            of people who click on our site through advertising. This enables us to use our advertising in a more
            targeted and therefore more effective manner.
          
            For more information please see Facebook&rsquo;s Cookie Policy. 
          </td>
          <td colSpan={1} rowSpan={1}>180 days<br />
            180 days<br />
            180 days<br />
            180 days<br />
            180 days<br />
            180 days</td>
        </tr>
        <tr>
          <td colSpan={1} rowSpan={1}>AnalyticsSyncHistory<br />
            UserMatch History<br />
            bcookie<br />
            lang<br />
            li_gc<br />
            li_mc<br />
            liap<br />
            lidc<br />
            lms_ads<br />
            lms_analytics</td>
          <td colSpan={1} rowSpan={1}>LinkedIn</td>
          <td colSpan={1} rowSpan={1}>The cookies we use from Linked In help us to understand the demographic of
            people who visit our website. This enables us to target our advertising more effectively.
          
            These cookies also allow for LinkedIn sharing buttons on the site, and save your language preference.
            
            For more information please see LinkedIn&rsquo;s Cookie Policy. 
          </td>
          <td colSpan={1} rowSpan={1}>30 days<br />
            30 days<br />
            2 years<br />
            Session<br />
            2 years<br />
            2 years<br />
            Session<br />
            24 hours<br />
            30 days<br />
            30 days</td>
        </tr>
        <tr>
          <td colSpan={1} rowSpan={1}>_hstc<br />
            hubspotutk<br />
            _hssc<br />
            _hssrc</td>
          <td colSpan={1} rowSpan={1}>HubSpot</td>
          <td colSpan={1} rowSpan={1}>These are non-essential cookies controlled by the cookie banner. You can opt
            out of these cookies.
          </td>
          <td colSpan={1} rowSpan={1}>13 months<br />
            13 months<br />
            30 minutes<br />
            Session</td>
        </tr>
        <tr>
          <td colSpan={1} rowSpan={1}>cookie_perms
            m</td>
          <td colSpan={1} rowSpan={1}>Stripe</td>
          <td colSpan={1} rowSpan={1}>The service through which all payments are made on our website. We do not store
            any bank details on our site.
          </td>
          <td colSpan={1} rowSpan={1}>Session<br />
            Session</td>
        </tr>
        <tr>
          <td colSpan={1} rowSpan={1}>_hjid<br />
            _hjViewportId<br />
            _hjFirstSeen<br />
            _hjIncludedInSessionSample</td>
          <td colSpan={1} rowSpan={1}>HotJar</td>
          <td colSpan={1} rowSpan={1}>HotJar cookies allow us to track where the most popular elements of the website
            are, and the effectiveness of the display.
          
            No personal data is retained by us. </td>
          <td colSpan={1} rowSpan={1}>365 days<br />
            Session<br />
            Session<br />
            Session</td>
        </tr>
        </tbody>
      </table>
      <p>In addition to the controls that we provide, you can choose to enable or disable Cookies in your internet
        browser. Most internet browsers also enable you to choose whether you wish to disable all Cookies, or only third
        party Cookies. By default, most internet browsers accept Cookies, but this can be changed. For further details
        please consult the help menu in your internet browser, or the documentation that came with your device.
      </p>
      <p>You can choose to delete Cookies on your computer or device at any time, however, you may lose any information
        that enables you to access our site more quickly and efficiently including, but not limited to, login and
        personalisation settings.
      </p>
      <p>It is recommended that you keep your internet browser operating system up-to-date and that you consult the help
        and guidance provided by the developer of your internet browser and manufacturer of your computer or device if
        you are unsure about adjusting your privacy settings.
      </p>
    </DefaultLayout>;
  }
}